// extracted by mini-css-extract-plugin
export default {"answer":"answer___e9e235c309640fac","field":"field___ee03a88cb5f98697","self":"self___a9a084641620ff55","text":"text___b2b9dcea09fc7756","label":"label___b09b446ef659d42a"};